class AssetEventsRequestBody {
  serial = undefined;
  activeOnly = false; // Required
  severities = []; // Required
  starting = undefined; // Required
  ending = undefined;
}

export default AssetEventsRequestBody;
